import { apiRequest } from '../../apiCall'
import { memberNotification, newCUstomer } from '../../types/customer/apiRequestType'


export const newCustomerRequest = (params: newCUstomer) => apiRequest('CustomerMember.NewCustomerMember', params, '', true)
export const deleteCustomerRequest = (id: string) => apiRequest('CustomerMember.Delete', {}, `?id=${id}`, true)
export const updateCustomerRequest = (params: newCUstomer) => apiRequest('CustomerMember.UpdateCustomerMember', params, '', true) 
export const ChangeMemberNotificationCustomerSetting=(params:memberNotification)=> apiRequest('CustomerMember.ChangeMemberNotificationSetting',params.list,'',false)
export const getCallTransferCustomerLineByCustomerMember=(Id:string)=> apiRequest('CustomerMember.GetCallTransferCustomerLineByCustomerMember',{}, `?customerMemberId=${Id}`,false)
export const getCustomerMemberQueueByCustumerMember=(Id:string)=>  apiRequest('CustomerMember.GetCustomerMemberQueueByCustomerMember',{}, `?customerMemberId=${Id}`,true)


